import collapseClasses from "@mui/material/Collapse/collapseClasses";
import listClasses from "@mui/material/List/listClasses";
import listItemButtonClasses from "@mui/material/ListItemButton/listItemButtonClasses";
import listItemClasses from "@mui/material/ListItem/listItemClasses";
import popoverClasses from "@mui/material/Popover/popoverClasses";
import { listItemSpacing } from "./List.module";
export const MuiListTheme = (dt) => {
    const listItemDepthCssSelector = (name, multiplier) => {
        let selector = "";
        for (let i = 0; i < multiplier; i++) {
            selector += ` .${name}`;
        }
        return `${selector} .${listClasses.root} > .${listItemButtonClasses.root}, ${selector} .${listClasses.root} > .${listItemClasses.root}`;
    };
    const getLevelStyling = (level) => {
        const vals = listItemSpacing(dt.size.small, level, dt.inset.squish.medium.horizontal);
        return {
            marginLeft: vals.spacing,
            [`&.${listItemClasses.gutters}, &.${listItemButtonClasses.gutters}`]: {
                marginLeft: vals.gutteredSpacing,
            },
        };
    };
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                [`.${popoverClasses.root}.Pxl-Menu-hPadding &`]: {
                    paddingLeft: dt.inline.small,
                    paddingRight: dt.inline.small,
                },
                [`${listItemDepthCssSelector(collapseClasses.root, 1)}`]: getLevelStyling(1),
                [`${listItemDepthCssSelector(collapseClasses.root, 2)}`]: getLevelStyling(2),
                [`${listItemDepthCssSelector(collapseClasses.root, 3)}`]: getLevelStyling(3),
                [`${listItemDepthCssSelector(collapseClasses.root, 4)}`]: getLevelStyling(4),
                [`${listItemDepthCssSelector(collapseClasses.root, 5)}`]: getLevelStyling(5),
                [`${listItemDepthCssSelector(collapseClasses.root, 6)}`]: getLevelStyling(6),
                [`${listItemDepthCssSelector(collapseClasses.root, 7)}`]: getLevelStyling(7),
                [`${listItemDepthCssSelector(collapseClasses.root, 8)}`]: getLevelStyling(8),
                [`${listItemDepthCssSelector(collapseClasses.root, 9)}`]: getLevelStyling(9),
                [`${listItemDepthCssSelector(collapseClasses.root, 10)}`]: getLevelStyling(10),
                [`${listItemDepthCssSelector(collapseClasses.root, 11)}`]: getLevelStyling(11),
                [`${listItemDepthCssSelector(collapseClasses.root, 12)}`]: getLevelStyling(12),
                [`${listItemDepthCssSelector(collapseClasses.root, 13)}`]: getLevelStyling(13),
                [`${listItemDepthCssSelector(collapseClasses.root, 14)}`]: getLevelStyling(14),
                [`${listItemDepthCssSelector(collapseClasses.root, 15)}`]: getLevelStyling(15),
            },
        },
    };
};
